import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CSpinner
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ObjectiveCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false,
      fields: [],
      creating: false
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const { id } = this.props.match.params;
    this.setState(
      () => ({
        loading: true
      }),
      () => {
        axios
          .get(`${URL.api}classification/thematic_unit/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            resp => {
              this.setState(
                () => {
                  let fieldsArray = this.fieldsMount(resp.data.data);
                  return {
                    fields: fieldsArray
                  };
                },
                () => {
                  if (!id) {
                    this.setState(() => ({
                      loading: false
                    }));
                  }
                }
              );
            },
            error => {
              this.error("Não foi possível obter as informações");
            }
          );
      }
    );

    if (id) {
      this.setState(
        () => ({
          loading: true
        }),
        () => {
          axios
            .get(`${URL.api}classification/objective/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(
              resp => {
                this.setState(
                  () => ({
                    objective: resp.data.data
                  }),
                  () => {
                    this.setState(() => ({
                      edit: true,
                      loading: false
                    }));
                  }
                );
              },
              error => {
                this.error("Não foi possível obter as informações");
              }
            );
        }
      );
    }
  }

  fieldsMount(thematicUnits) {
    let optionsThematicUnitsArray = [];
    for (let i = 0; i < thematicUnits.length; i++) {
      let obj = {
        value: thematicUnits[i].id,
        label: thematicUnits[i].name,
        name: thematicUnits[i].name
      };
      optionsThematicUnitsArray[i] = obj;
    }

    let Fields = [
      {
        name: "description",
        label: "Descrição",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required]
      },
      {
        name: "order",
        label: "Ordem",
        type: "number",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "thematic_unit_id",
        label: "Unidade Temática",
        type: "select",
        required: true,
        options: optionsThematicUnitsArray,
        icon: "fa fa-text-width",
        validate: [required]
      }
    ];

    return Fields;
  }

  enviar(value) {
    this.setState({ creating: true });

    let obj = {
      description: value.description,
      order: value.order,
      thematic_unit_id: value.thematic_unit_id
    };

    axios
      .post(`${URL.api}classification/objective/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/objective/list");
            this.setState({ creating: false });
          } else {
            this.error("Não foi possível criar o objetivo");
            this.setState({ creating: false });
          }
        },
        error => {
          this.error("Não foi possível criar o objetivo");
          this.setState({ creating: false });
        }
      );
  }

  atualizar(value) {
    this.setState({ creating: true });

    let obj = {
      description: value.description,
      order: value.order,
      thematic_unit_id: value.thematic_unit_id
    };

    axios
      .post(`${URL.api}classification/objective/update/${value.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/objective/list");
            this.setState({ creating: false });
          } else {
            this.error("Não foi possível editar o objetivo");
            this.setState({ creating: false });
          }
        },
        error => {
          this.error("Não foi possível editar o objetivo");
          this.setState({ creating: false });
        }
      );
  }

  render() {
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/objective/list", to: "/objective/list" }]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Objetivo" : "Criar Objetivo"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o objetivo selecionado"
                    : "Crie um novo objetivo"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={this.state.creating}
              >
                <>
                  <span style={this.state.creating ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.creating && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <Form
                avatar
                fields={this.state.fields}
                history={this.props.history}
                onSubmit={this.state.edit ? this.atualizar : this.enviar}
                initialValues={this.state.objective}
                edit={this.state.edit}
                ref={this.formRef}
              />
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ObjectiveCreate);
